import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "targets-list" }
const _hoisted_2 = {
  key: 0,
  class: "text-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h3", null, _toDisplayString(_ctx.t('fleet.clusterTargets.rules.matching.title')), 1),
    _cache[0] || (_cache[0] = _createTextVNode()),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.names, (name, i) => {
      return (_openBlock(), _createElementBlock("span", {
        key: i,
        class: "row mt-5"
      }, _toDisplayString(name), 1))
    }), 128)),
    _cache[1] || (_cache[1] = _createTextVNode()),
    (!$options.names.length)
      ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString($props.emptyLabel || _ctx.t('fleet.clusterTargets.rules.matching.empty')), 1))
      : _createCommentVNode("", true)
  ]))
}